<template>
    <div id="social-share-app">
        <ShareButtons />
    </div>
</template>

<script>
    import ShareButtons from './components/ShareButtons.vue'

    export default {
        name: 'SocialShare',
        components: {ShareButtons},
        data () {
            return {

            }
        },
        methods: {

        }
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/SocialShare.vue